var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageType === 'pc')?_c('pc'):_vm._e(),(_vm.pageType === 'mobile')?_c('mobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }